import { Card, styled } from '@mui/material';

export const ViewDocumentDetailsDrawerStyled = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    padding: '2rem',
    border: '1px solid rgba(0,0,0,0.1)',
    borderRadius: '1rem',
  },
  '& .document-details-card': {
    display: 'flex',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },
  '& .timeline': {
    marginLeft: theme.spacing(12),
    [theme.breakpoints.down('md')]: {
      marginLeft: '0',
      marginTop: theme.spacing(12),
    },
  },
}));

export const ViewDocumentDetailsDrawerCardStyled = styled(Card)(() => ({
  width: 'fit-content',
  borderRadius: '1rem',
  '& .card-div': {
    backgroundColor: 'rgba(201, 201, 201, 0.2)',
    padding: '0.5rem 2.5rem',

    '&.isPdf': {
      padding: '0.5rem',
    },

    '& .pdf-icon': {
      cursor: 'pointer',
      margin: '30px auto',
    },

    '& a .pdf-icon': {
      margin: '40px auto',
    },
  },
  '& img': {
    width: '150px',
    height: '192px',
    borderRadius: '0.5rem',
    cursor: 'pointer',
  },
}));

export const PreviewDocumentPdfStyled = styled('object')(() => ({
  boxShadow:
    'rgba(0, 0, 0, 0.2) 0px 2px 1px -1px, rgba(0, 0, 0, 0.14) 0px 1px 1px 0px, rgba(0, 0, 0, 0.12) 0px 1px 3px 0px',
  borderRadius: '1rem',
  backgroundColor: '#FFFFFF',
}));
